import { apiSlice } from '../../store/api/apiSlice';

interface MailRequestPayload {
  request_type: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  secondary_mail_id: string;
  preferred_mail_id: string;
  additional_remarks: string;
}

export interface MailRequestRecord {
  id: number;
  request_type: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  secondary_mail_id: string;
  preferred_mail_id: string;
  additional_remarks: string;
  password: string;
  backup_code: string;
  status: number;
  request_status: string;
  mfastatus: number;
  created_at: string;
}

export const mailRequestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMailRequest: builder.mutation<any, MailRequestPayload>({
      query: (payload) => ({
        url: 'createMailRequest',
        method: 'POST',
        body: { records: payload },
        service: 'djangoTnEmis',
      }),
      invalidatesTags: ['MailRequest'],
    }),

    bulkCreateMailRequests: builder.mutation<any, MailRequestPayload[]>({
      query: (records) => ({
        url: 'bulkCreateMailRequests',
        method: 'POST',
        body: { records },
        service: 'djangoTnEmis',
      }),
      invalidatesTags: ['MailRequest'],
    }),

    getMailRequests: builder.query<MailRequestRecord[], void>({
      query: () => ({
        url: 'getMailRequests',
        method: 'GET',
        service: 'djangoTnEmis',
      }),
      transformResponse: (response: any) => response?.result ?? [],
      providesTags: ['MailRequest'],
    }),
  }),
});

export const {
  useCreateMailRequestMutation,
  useBulkCreateMailRequestsMutation,
  useGetMailRequestsQuery,
} = mailRequestApi;
